export const AVAILABILITY_OPTIONS = {
  DEFAULT_ON: 'default_on',
  DEFAULT_OFF: 'default_off',
  NEVER_ON: 'never_on',
};
